export default "__VITE_ASSET__sEkW5i7J__"